import { createSlice } from '@reduxjs/toolkit';
const initialCounts = {
  M: {
    Bags: 5000,
    Belt: 5000,
    'Caps & Hats': 2500,
    'Coats, Suits, Blazers': 25000,
    'Ethinic Wear': 20000,
    Footwear: 25000,
    Jackets: 25000,
    Jeans: 37500,
    'Lounge Coords': 25000,
    Shirts: 50000,
    Shorts: 15000,
    Sunglasses: 25000,
    'Sweaters & Cardigans': 30000,
    'Sweatshirts & Hoodies': 37500,
    'Track/ Sweat/ Pyjama Pants': 25000,
    Trousers: 37500,
    Tshirts: 50000
  },
  F: {
    Topwear: 100000,
    Bags: 25000,
    Belt: 5000,
    'Caps & Hats': 2500,
    'Coats, Suits, Blazers': 15000,
    Dresses: 100000,
    Dungaree: 0,
    'Ethinic Wear': 25000,
    Footwear: 25000,
    Glove: 2500,
    Jackets: 25000,
    Jeans: 25000,
    Jumpsuits: 5000,
    Leggings: 10000,
    'Lingerie & Swimwear': 15000,
    'Lounge Coords': 25000,
    'Other Outerwear': 5000,
    Shirts: 10000,
    Shorts: 5000,
    Skirts: 25000,
    Skorts: 0,
    'Socks & Stockings': 5000,
    Sunglasses: 15000,
    'Sweaters & Cardigans': 50000,
    'Sweatshirts & Hoodies': 25000,
    'Track/ Sweat/ Pyjama Pants': 25000,
    Trousers: 30000,
    Tshirts: 25000
  }
}
const styleProcudeCounts = createSlice({
  name: "styleProcudeCounts",
  initialState: initialCounts,
  reducers: {
    updateCategoryCount: (state, param) => {
      state[param.payload.gender][param.payload.category] = param.payload.count
    },
  }
});


const { actions, reducer } = styleProcudeCounts
export const { updateCategoryCount } = actions;
export default reducer;
